import React, { useEffect, useMemo } from "react";

import { useFormContext, useWatch } from "react-hook-form";

import { ONLINE_USER_WALLETS } from "@common/constants/wallets/OnlineUserWallets";
import { FormSelectField } from "@components-shared/desktop/inputs";
import { useRootAppStore } from "@hooks";
import { observer } from "mobx-react-lite";

export default observer(function AccountStatementShopUserShopDropdown() {
	const rootStore = useRootAppStore();
	const watchBettingAccountType = useWatch({
		name: "bettingAccountTypeAbrv",
	});

	const watchShopId = useWatch({
		name: "shopId",
	});

	const form = useFormContext();

	const isOnlineWallet = ONLINE_USER_WALLETS.has(watchBettingAccountType);

	const mapToShops = useMemo(() => {
		return Array.from(rootStore.userAuthStore.shopUserShops.values()).map(
			(shop) => ({
				name: shop.displayName,
				id: shop.shopId,
				value: shop.shopId,
			})
		);
	}, [rootStore.userAuthStore.shopUserWallets]);

	useEffect(() => {
		const currentShopId = form.getValues("shopId");
		if (isOnlineWallet) {
			if (
				!currentShopId ||
				!rootStore.userAuthStore.onlineUserShops.has(currentShopId)
			)
				form.setValue(
					"shopId",
					rootStore.userAuthStore.defaultOnlineShopId
				);
		} else {
			if (
				!currentShopId ||
				!rootStore.userAuthStore.shopUserShops.has(currentShopId)
			) {
				form.setValue(
					"shopId",
					rootStore.userAuthStore.activeShopUserShopId
				);
			}
		}
	}, [watchBettingAccountType]);

	useEffect(() => {
		if (!isOnlineWallet) {
			const currentShopId = form.getValues("shopId");
			const shop =
				rootStore.userAuthStore.shopUserShops.get(currentShopId);
			if (!shop) {
				return;
			}
			if (!shop.wallets.some((w) => w.abrv == watchBettingAccountType)) {
				form.setValue("bettingAccountTypeAbrv", shop.wallets[0].abrv);
			}
		}
	}, [watchShopId]);

	if (!rootStore.userAuthStore.isMultiCardUser) {
		return null;
	}

	if (isOnlineWallet) {
		return null;
	}

	return (
		<FormSelectField
			className="form__group"
			label="COMMON.SELECT_SHOP"
			name="shopId"
			dropdownData={mapToShops}
		/>
	);
});
